import {Directive, EmbeddedViewRef, Input, OnChanges, SimpleChange, TemplateRef, ViewContainerRef} from "@angular/core";
import {SearchFormExtendedService} from "../search-form-extended.service";

/**
 * Component to load a template for a form field
 */
@Directive({
    selector: "[searchFormFieldTemplateLoader]"
})
export class SearchFormFieldTemplateLoader implements OnChanges {

    private embeddedViewRef: EmbeddedViewRef<any>;

    @Input() searchFormFieldTemplateLoader: TemplateRef<any>;

    @Input() formFieldKey: string;

    constructor(private viewContainer: ViewContainerRef, private searchFormExtendedService: SearchFormExtendedService) {
    }

    ngOnChanges(changes: { [key: string]: SimpleChange }) {
        if (this.embeddedViewRef) {
            this.embeddedViewRef.destroy();
        }
        this.searchFormExtendedService.currentExtendedField = this.formFieldKey;
        this.embeddedViewRef = this.viewContainer.createEmbeddedView(this.searchFormFieldTemplateLoader);
    }
}
